import React from 'react'
import StepManager from '../components/stepManager';
import { Redirect } from 'react-router-dom';
import { UiGetCustomer, documentation as UiGetCustomerDoc } from "./uiGetCustomer";
import{ UiGetDashboard, documentation as UiGetDashboardDoc }from "./uiGetDashboard";

let documentation = {
    title: "Assign Dashboard",
    brief: "Assign an existing dashboard to another customer.",
    content: "Assign an existing dashboard to a customer. The previously assigned customers maintains their dashboard ownership",

    steps:[
        {
            id:0, ...UiGetCustomerDoc
        },
        {
            id:1, ...UiGetDashboardDoc
        }
    ]
}

class UiAssignDashboard extends React.Component {

    static defaultProps = {};
    constructor(props) {
        super(props);
        this.stepManagerRef = React.createRef();
        this.state = {
            finished: false,
            nextRoute: this.props.nextRoute,

            customers: { name: '', instances: [] },
            field: { data: null, report: null },
        };
    }

    documentation = () => documentation;

    stepManagerAdvance = () => {
        const element = this.stepManagerRef.current;
        element.advance();
    };

    renderGetCustomerForm = () => {
        return (
            <UiGetCustomer
                error={this.handleSubmitError}
                services={{ customer: this.props.services.customer }}
                finished={(report) => {
                    this.setState({ customers: report });
                    this.stepManagerAdvance();
                }
                } />
        );
    };

    renderGetDashboard = () => {
        return (
            <UiGetDashboard
                services={{
                    dashboard: this.props.services.dashboard
                }}
                customers={this.state.customers}
                finished={(data) => {
                    this.setState({ dashboards: data });
                    this.stepManagerAdvance();
                }} />
        );
    };

    render() {
        return (
            <div>
                <div className="container-fluid">
                    {this.state.finished && <Redirect to={this.props.nextRoute} />}
                    <StepManager ref={this.stepManagerRef}
                        startStepId={0} endStepId={1}
                        onFinished={() => {
                            window.open(this.props.links.thingsboardRoutes.dashboards);
                            this.setState({ finished: true })
                        }}
                        documentation= {this.documentation()}
                        stepList={[
                            { stepId: 0, stepName: this.documentation().steps[0].title, 
                                formValue: this.renderGetCustomerForm, documentation: this.documentation().steps[0] },
                            { stepId: 1, stepName: this.documentation().steps[1].title, 
                                formValue: this.renderGetDashboard, documentation: this.documentation().steps[1]},
                        ]} />
                </div>
            </div>);
    }
}


export default UiAssignDashboard;
export {UiAssignDashboard, documentation}